import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";

// firebase.ts uses a top-level await to load config, so the module graph
// is fully resolved (and Firebase initialized) before we render.
async function mount() {
  await import("./firebase");
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}

mount();
